import { Box, Button, useMediaQuery } from "@material-ui/core";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CheckIcon from "@material-ui/icons/Check";

import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { useSelectAddOnsExtraServicesStyles } from "./AddOnItem.styles";
import { AddOnItemDetails } from "./AddOnItemDetails";
import { QuoteLineItem } from "../../../../api/Quote/QuoteLineItem";
import { quateAddonQuantityValue } from "../../../../app/utils";
import { addAddonQuote, changeQuantityAddonQuote } from "../../../../store/QuoteSlice";
import { AddonForm } from "../../../../api/Addon/AddonApi";
import { eventAnalytic } from "../../../../app/analytics";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

export const AddOnItem = ({ isfirst, item, quoteId }: { isfirst: boolean; item: QuoteLineItem; quoteId: string }) => {
  const { isMoreThanSm } = useBreakpoint();
  const classes = useSelectAddOnsExtraServicesStyles();
  const matchesSmallMobile = useMediaQuery("(max-width:376px)");
  const dispatch = useDispatch();

  const onChangeQuantity = (addon: QuoteLineItem, quantity: number) => {
    dispatch(
      changeQuantityAddonQuote(quoteId, {
        addonId: addon.productId,
        quantity: quantity
      } as AddonForm)
    );
  };

  const onAddAddon = (addon: QuoteLineItem) => {
    eventAnalytic.record(addon);
    dispatch(
      addAddonQuote(quoteId, {
        addonId: addon.productId,
        quantity: addon.quantity
      } as AddonForm)
    );
    toast.success(addon.name + " has been added");
  };

  return (
    <Box display="flex" borderTop={!isfirst ? "solid 1px #efefef" : "none"}>
      <Box
        p={isMoreThanSm ? 2 : 1}
        border={"solid 1px #dfdfdf"}
        marginTop={!isfirst ? 5 : 0}
        marginBottom={5}
        marginRight={isMoreThanSm ? 5 : "18px"}
        width={isMoreThanSm ? 137 : 80}
        height={isMoreThanSm ? 137 : 80}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <img
          width={isMoreThanSm ? 83 : 47}
          height={isMoreThanSm ? 114 : 64}
          style={{ objectFit: "contain" }}
          alt={item.name}
          src={item.imageUrl}
        />
      </Box>
      <Box>
        <Box mt={!isfirst ? 5 : 0} className={classes.title}>
          {item.name}
        </Box>
        <Box className={classes.content}>
          <span className="description">{item.highLevelDescription} </span>
          <AddOnItemDetails item={item} onChangeQuantity={onChangeQuantity} onAddAddon={onAddAddon} />
        </Box>
        <Box className={classes.price}>
          <PriceFormat value={quateAddonQuantityValue(item)} />
        </Box>
        <Box
          display="flex"
          flexWrap={matchesSmallMobile ? "wrap" : "nowrap"}
          justifyContent={!isMoreThanSm ? "space-between" : ""}
          mb={isMoreThanSm ? "32px" : 1}
        >
          <Box className={classes.showQuantity}>
            <button
              onClick={() => {
                onChangeQuantity(item, item.quantity - 1);
              }}
              disabled={item.quantity === 1}
              className={classes.button}
            >
              <RemoveIcon fontSize="small" />
            </button>
            <span>{item.quantity}</span>
            <button
              className={classes.button}
              disabled={item.quantity === item.maxQuantity}
              onClick={() => {
                onChangeQuantity(item, item.quantity + 1);
              }}
            >
              <AddIcon />
            </button>
          </Box>
          <Box marginTop={matchesSmallMobile ? "15px" : 0}>
            <Button className={classes.add} onClick={() => onAddAddon(item)} disabled={item.selected}>
              {item.selected && <CheckIcon />}
              {item.selected ? "Added" : "Add"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
